var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page--dashboard"},[_c('h1',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('general.message.welcome_name', {name: _vm.$user.firstName})))]),_c('p',[_vm._v(_vm._s(_vm.$t('dashboard.message.introduction')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }